import * as yup from "Utils/yup";
import { SessionConfigurationFormData } from "./types";

export const SessionConfigurationFormSchema: yup.SchemaOf<SessionConfigurationFormData> =
  yup.object({
    persistent_session: yup.string().required(),
    refresh_session_on_activity: yup.boolean().required(),
    enable_inactivity_timeout: yup.boolean().default(false),
    max_session_duration_minutes: yup.number().required(),
    inactivity_timeout_minutes: yup
      .number()
      .required()
      .when("enable_inactivity_timeout", {
        is: true,
        then: (schema) =>
          schema.test(
            "inactivityPeriodShorterThanSessionDuration",
            "Inactivity period cannot be greater than maximum session duration",
            function (value: number, testContext: yup.TestContext) {
              return value <= testContext.parent.max_session_duration_minutes;
            },
          ),
      }),
  });
